/***
 * Summary: here resides the scheme and roles for the fields of the network performing
 * 
 */
import { yupToFormErrors } from "formik";
import * as Yup from "yup";

const TODIS_RAILBORDERCROSS_SCHEMA = Yup.object().shape({
    //general section Rules:
    nameResp: Yup.string("nameResp Is alphanumeric").nullable(true),
    addressResp: Yup.string("Road ID is alphanumeric").nullable(true),
    contactPer: Yup.string("Road ID is alphanumeric").nullable(true),
    contactPos: Yup.string("tent category is alphanumeric").nullable(true),
    contactNum: Yup.string()
        .transform((originalValue) => {
            // Si el valor comienza con '+', eliminamos ese símbolo
            return typeof originalValue === 'string' ? originalValue.replace(/^\+/, '') : originalValue;
        })
        .nullable(true)
        .test('is-valid', 'Invalid data. \'Phone Number\' must be a valid number', function (value) {
            // Permitir números, espacios, y la presencia de '+'
            const isValid = /^[0-9+\s]+$/.test(value) || value === null;

            if (!isValid) {
                throw this.createError({ message: 'Invalid data. \'Phone Number\' must be a valid number' });
            }

            return true;
        }),

    contactEmail: Yup.string("Email")
        .transform((originalValue) => {
            // Realizar transformaciones si es necesario
            return typeof originalValue === 'string' ? originalValue.trim() : originalValue;
        })
        .nullable(true)
        .test('is-email', 'Invalid data. \'Email\' must be valid', function (value) {
            // Si el valor es null, lo consideramos válido y no aplicamos más validaciones
            if (value === null) {
                return true;
            }

            const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
            const emails = value.split(/[,;:]+/);  // Separar por comas, punto y coma, o dos puntos

            for (const email of emails) {
                if (!emailRegex.test(email.trim())) {
                    throw this.createError({ message: `Invalid data. '${email}' must be a valid email address` });
                }
            }

            return true;
        }),

    countryCode: Yup.string("Country Code").nullable(true),
    tenTCategory: Yup.string("Road ID is alphanumeric").nullable(true),
    borderCrossName: Yup.number("Must be a number").nullable(true),
    routeId: Yup.string("Road ID is alphanumeric").nullable(true),
    owner1: Yup.string("Road ID is alphanumeric").nullable(true),
    owner1Per: Yup.string("Route Id").nullable(true),
    ownerOther: Yup.string("Road ID is alphanumeric").nullable(true),
    ownerOtherPer: Yup.string("Road ID is alphanumeric").nullable(true),
    dateValidFrom: Yup.date("Valid from is a Date").required().nullable(true),
    dateValidTo: Yup.date("Valid to is a Date").required().nullable(true),
    dateValidFor: Yup.string("Valid for is a Year"),
    greenLanes: Yup.string("Road ID is alphanumeric").nullable(true),
    oneStopProcedure: Yup.string("Road ID is alphanumeric").nullable(true),
    oneStopProcedureType: Yup.string("GreenLanes Is alphanumeric").nullable(true),
    contolType: Yup.string("oneStopProcedure Is alphanumeric").nullable(true),
    borderWith: Yup.string("oneStopProcedureType Is alphanumeric").nullable(true),
    remarks: Yup.string("description").required("Required Description").nullable(true),

    RailwaysBorderCrossingNpmOper: Yup.object().shape({
        passengerTrainsEnt: Yup.number('Value should be number').nullable(true),
        freightTrainsEnt: Yup.number('Value should be number').nullable(true),
        dangerousGoodsTrainsEnt: Yup.number('Value should be number').nullable(true),
        passengerTrainsAveEntryTime: Yup.number('Value should be number').nullable(true),
        freightTrainAveEntryTime: Yup.number('Value should be number').nullable(true),
        passengerTrainsExit: Yup.number('Value should be number').nullable(true),
        freightTrainsExit: Yup.number('Value should be number').nullable(true),
        dangerousGoodsTrainsExit: Yup.number('Value should be number').nullable(true),
        passengerTrainsAveExitTime: Yup.number('Value should be number').nullable(true),
        freightTrainAveExitTime: Yup.number('Value should be number').integer('Value should be an integer').nullable(true),
        reqUpgradeIncCapacity: Yup.boolean().nullable(true),
        requUpgradeIts: Yup.boolean().nullable(true),
        remarks: Yup.string("description").nullable(true),
    })
});




const RAILBORDERCROSS_INIT = {
    //general section Rules:
    nameResp: "",
    addressResp: "",
    contactPer: "",
    contactPos: "",
    contactNum: 0,
    contactEmail: "",
    countryCode: "",
    tenTCategory: "",
    borderCrossName: "",
    routeId: "",
    owner1: "",
    owner1Per: "",
    ownerOther: "",
    ownerOtherPer: "",
    dateValidFrom: "",
    dateValidTo: "",
    dateValidFor: "",
    greenLanes: "",
    oneStopProcedure: "",
    oneStopProcedureType: "",
    contolType: "",
    borderWith: "",
    remarks: "",
    RailwaysBorderCrossingNpmOper: {
        passengerTrainsEnt: 0,
        freightTrainsEnt: 0,
        dangerousGoodsTrainsEnt: 0,
        passengerTrainsAveEntryTime: 0,
        freightTrainAveEntryTime: 0,
        passengerTrainsExit: 0,
        freightTrainsExit: 0,
        dangerousGoodsTrainsExit: 0,
        passengerTrainsAveExitTime: 0,
        freightTrainAveExitTime: 0,
        reqUpgradeIncCapacity: false,
        requUpgradeIts: false,
        remarks: "",
    }
}

export { TODIS_RAILBORDERCROSS_SCHEMA, RAILBORDERCROSS_INIT };